/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ThursdayInputs */

const en_thursday = /** @type {(inputs: ThursdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thursday`)
};

const de_thursday = /** @type {(inputs: ThursdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnerstag`)
};

/**
* | output |
* | --- |
* | "Thursday" |
*
* @param {ThursdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thursday = /** @type {((inputs?: ThursdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ThursdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thursday(inputs)
	return de_thursday(inputs)
});